import { render } from "./StudyCardModal.vue?vue&type=template&id=5b5547fb&scoped=true"
import script from "./StudyCardModal.vue?vue&type=script&lang=js"
export * from "./StudyCardModal.vue?vue&type=script&lang=js"

import "./StudyCardModal.vue?vue&type=style&index=0&id=5b5547fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b5547fb"]])

export default __exports__